import { graphql } from '@/client/services/api/graphql/gql';

export const updateExpertMutation = graphql(`
  mutation UpdateExpert($expertId: String!, $updateBody: ExpertUpdateInput!) {
    updateExpert(expertId: $expertId, updateBody: $updateBody)
  }
`);
